<div class="overflow-y-auto h-full flex flex-col p-4">
	<div class="xl:flex justify-between">
		<div class="mb-3">
			<h3>
				<a
					routerLink=".."
					class="mr-2 text-green underline"
					[testHook]="testHooks.ApsIntakeLink"
					>APS Intake</a
				>
				/ Deposits
			</h3>
		</div>
		<span class="flex items-center">
			<app-button
				btn="primary"
				[icon]="ICON.ADD"
				(click)="addDeposit()"
				size="small"
				[testHook]="testHooks.AddAnotherDepositButton"
				>Add another deposit</app-button
			>
		</span>
	</div>
	<div class="flex flex-1 flex-row overflow-y-auto h-full" #depositList>
		<div class="w-full">
			<div class="mt-5">
				<div class="deposit-list">
					<ng-container
						*ngFor="
							let deposit of adjustment?.deposits;
							trackBy: depositCompoundIndex;
							let i = index
						"
					>
						<app-container
							*ngIf="deposit"
							type="dark"
							title="Deposit {{ i + 1 }}"
							class="mt-3 rounded-xl border-grey-lighter p-1"
							[testHook]="testHooks.DepositContainer"
						>
							<div header *ngIf="adjustment.deposits.length > 1">
								<app-button
									btn="tertiary"
									[icon]="ICON.DELETE"
									[holdable]="true"
									(onClick)="removeDeposit(i)"
									[testHook]="testHooks.DeleteButton"
								></app-button>
							</div>
							<app-date-picker
								label="Date"
								name="date"
								[(ngModel)]="deposit.date"
								(ngModelChange)="changed()"
								[testHook]="testHooks.DateDatePicker"
							></app-date-picker>
							<app-input
								type="cents"
								label="Amount"
								name="amount"
								class="mt-3"
								[startIcon]="ICON.DOLLAR"
								[(ngModel)]="deposit.amount"
								(ngModelChange)="changed()"
								[testHook]="testHooks.Amount"
							></app-input>
						</app-container>
					</ng-container>
				</div>

				<div class="flex justify-between p-4 sticky bottom-0 bg-white">
					<app-button
						btn="tertiary"
						class="mr-5"
						(click)="cancelModal()"
						size="small"
						[testHook]="testHooks.CancelButton"
						>Cancel</app-button
					>
					<app-button
						(click)="saveModal()"
						size="small"
						[testHook]="testHooks.SaveButton"
						>Save</app-button
					>
				</div>
			</div>
		</div>
	</div>
</div>
